// Author YuJiaBei
// Date 2020-12-02 16:57:55

class EmAdmNotification {
constructor({
        id = null,
        title = '',
        content = '',
        date = '',
        menuId = '',
        fromUser = '',
        targetUser = '',
        type = '',
        status = '',
        link = ''}
= {}) {
    this.id = id;
    this.title = title;
    this.content = content;
    this.date = date;
    this.menuId = menuId;
    this.fromUser = fromUser;
    this.targetUser = targetUser;
    this.type = type;
    this.status = status;
    this.link = link;
}
}

function newEntity() {
return new EmAdmNotification();
}

    function gridFields() {
    return Object.freeze([
        {
        key: 'title',
        label: 'label.em.admin.emAdmNotification.grid.title',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'content',
        label: 'label.em.admin.emAdmNotification.grid.content',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'date',
        label: 'label.em.admin.emAdmNotification.grid.date',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'menuId',
        label: 'label.em.admin.emAdmNotification.grid.menuId',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'fromUser',
        label: 'label.em.admin.emAdmNotification.grid.fromUser',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'targetUser',
        label: 'label.em.admin.emAdmNotification.grid.targetUser',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'type',
        label: 'label.em.admin.emAdmNotification.grid.type',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'status',
        label: 'label.em.admin.emAdmNotification.grid.status',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'link',
        label: 'label.em.admin.emAdmNotification.grid.link',
        sortable: true,
        form: {
        type: 'input'
        }
        }
    ])}

const filter = {
    titleFilter : "",
    contentFilter : "",
    dateRteFilter : "",
    dateLteFilter : "",
    menuIdFilter : "",
    fromUserFilter : "",
    targetUserFilter : "",
    typeFilter : "",
    statusFilter : "",
    linkFilter : ""
};

const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));

const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));

const filterConfigs = [
        {
        key: 'titleFilter',
        label: 'label.em.admin.emAdmNotification.filter.title',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'contentFilter',
        label: 'label.em.admin.emAdmNotification.filter.content',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'dateRteFilter',
        label: 'label.em.admin.emAdmNotification.filter.dateRte',
        disabled: false,
        form: {
        type: 'datepicker'
                }
        },
        {
        key: 'dateLteFilter',
        label: 'label.em.admin.emAdmNotification.filter.dateLte',
        disabled: false,
        form: {
        type: 'datepicker'
                }
        },
        {
        key: 'menuIdFilter',
        label: 'label.em.admin.emAdmNotification.filter.menuId',
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'fromUserFilter',
        label: 'label.em.admin.emAdmNotification.filter.fromUser',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'targetUserFilter',
        label: 'label.em.admin.emAdmNotification.filter.targetUser',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'typeFilter',
        label: 'label.em.admin.emAdmNotification.filter.type',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'statusFilter',
        label: 'label.em.admin.emAdmNotification.filter.status',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'linkFilter',
        label: 'label.em.admin.emAdmNotification.filter.link',
        disabled: false,
        form: {
        type: 'input'
                }
        }
];


    const entityFormConfigs = [
        {
        key: 'title',
        label: 'label.em.admin.emAdmNotification.entity.title',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'content',
        label: 'label.em.admin.emAdmNotification.entity.content',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'date',
        label: 'label.em.admin.emAdmNotification.entity.date',
        sortable: true,
        disabled: false,
        form: {
        type: 'datepicker'
                }
        },
        {
        key: 'menuId',
        label: 'label.em.admin.emAdmNotification.entity.menuId',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'fromUser',
        label: 'label.em.admin.emAdmNotification.entity.fromUser',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'targetUser',
        label: 'label.em.admin.emAdmNotification.entity.targetUser',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'type',
        label: 'label.em.admin.emAdmNotification.entity.type',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'status',
        label: 'label.em.admin.emAdmNotification.entity.status',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'link',
        label: 'label.em.admin.emAdmNotification.entity.link',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        }
]

export {EmAdmNotification, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
, filterConfigs


}
